<template>
  <div class="block-houen-menus" :style="styles">
    <h3 v-if="!!listInfo && listType"><img :src="listInfo.headImage" alt="" class="headtitle"></h3>
    <div class="list-wrap">
      <div
        class="list-item"
        v-for="(item, idx) in menuList"
        @click="onListItemClick(item.url)"
        :key="idx"
      >
        <span class="rank-str" v-if="+menuData.is_ranking > 0">{{idx + 1 | formatRankStr}}</span>
        <div class="list-item-wrap">
          <span class="icon" v-if="enableIcon && !!item.icon && +item.icon > 0" :class="{[`icon-type${item.icon}`]:true}"></span>
          <span class="title">{{item.title}}</span>
        </div>
      </div>
    </div>
     <div class="update-message" v-if="!!menuData.update_str" v-html="menuData.update_str"></div>
  </div>
</template>

<script>
const HOUEN_LIST_MASTER = {
  id1: {
    headImage: '/static/img/recommend/lp/houen/products/menu_list/head_newarrival.png',
  },
  id2: {
    headImage: '/static/img/recommend/lp/houen/products/menu_list/head_ranking.png',
  },
  id3: {
    headImage: '/static/img/recommend/lp/houen/products/menu_list/head_recommend.png',
  },
  id4: {
    headImage: '/static/img/recommend/lp/houen/products/menu_list/head_by_situation.png',
  },
  id5: {
    headImage: '/static/img/recommend/lp/houen/products/menu_list/head_special_detailed_appraisal.png',
  },
}

export default {
  name: 'BlockHouenMenus',
  props: {
    menuData: {
      type: Object,
    },
    enableIcon: {
      type: Boolean,
      default: true,
    },
    itemIndex: {
      type: Number,
      default: -1,
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    listType() {
      return !!this.menuData +this.menuData.id > 0 ? +this.menuData.id : null
    },
    listInfo() {
      if(!!this.listType) {
        return HOUEN_LIST_MASTER[`id${this.listType}`]
      }
    },
    menuList() {
      return !!this.menuData ? this.menuData.list : null
    },
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  },
  mounted() {
    // console.log('　　リスト枠のアイテム[%O] master[%O]', this.menuData, this.listInfo)
  },
  methods: {
    onListItemClick(url) {
      location.href = this.$handoverParams(url)
    }
  },
  filters: {
    formatRankStr(val) {
      const rank = String(val).replace(/\d/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0));
      return `\\${rank}位/`
    }
  }
}</script>

<style scoped lang="scss">

@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);


$col_border: #dadada;

.block-houen-menus {
  background: #fff;
  border: 1px solid $l_col_keycolor;
  border-radius:10px ;
  padding: 32px 20px 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: $col_base_black;
  h3 {
    margin: 0 auto 16px;
    img {
      width: 100%;
      max-width: 280px;
      margin: auto;
      display: block;
    }
  }
  .list-wrap {
    .list-item {
      &:first-child {
        .rank-str {
          padding: 0 0 0;
        }
      }
      &:last-child {
        .list-item-wrap {
          border: none;
        }
      }
      .rank-str {
        display: inline-block;
        width: 100%;
        padding: 16px 0 0;
      }
      .list-item-wrap {
        height: 68px;
        padding-right: 24px;
        display: flex;
        position: relative;
        border-bottom: 1px solid $col_border;
        align-items: center;
        cursor: pointer;
        .icon {
          height: 3.2em;
          width: 3.2em;
          margin-right: 0.8em;
          display: inline-block;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% auto;
          &.icon-type1 {
            background-image: url(/static/img/recommend/lp/houen/products/menu_list/ic_renai.svg);
          }
          &.icon-type2 {
            background-image: url(/static/img/recommend/lp/houen/products/menu_list/ic_shigoto.svg);
          }
          &.icon-type3 {
            background-image: url(/static/img/recommend/lp/houen/products/menu_list/ic_jinsei.svg);
          }
        }
        .title {
          flex: 1;
          max-width: 80%;
          @include mq('w580'){
            font-size: 16px;
          }
        }
        &::after {
          content:'';
          border-top:2px solid var(--second);
          border-right:2px solid var(--second);
          position: absolute;
          width: 10px;
          height: 10px;
          right: 10px;
          top: 43%;
          transform: rotate(45deg);
        }
      }
    }
  }
  .update-message {
    text-align: center;
    padding: 20px 0 10px;
    border-top: 1px solid $col_border;
    display: inline-block;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockHouenMenus.vue